import * as React from 'react';
export const headerText = 'The spectacle before us was indeed sublime';
export const longText = `
  Apparently we had reached a great height in the atmosphere, for the sky was
  a dead black, and the stars had ceased to twinkle. By the same illusion which
  lifts the horizon of the sea to the level of the spectator on a hillside, the
  sable cloud beneath was dished out, and the car seemed to float in the middle
  of an immense dark sphere, whose upper half was strewn with silver.
  Looking down into the dark gulf below, I could see a ruddy light streaming
  through a rift in the clouds.
`;
export const shortText = 'Vestibulum id ligula porta felis euismod semper eget lacinia odio sem.';
export const characters = (React.createElement(React.Fragment, null,
    "A B C D E F G H I J K L M N O P Q R S T U V W X Y Z \u00C4 \u00D6 \u00DC \u00C0 \u00C2 \u00C8 \u00C9 \u00CA \u00CB \u00CE \u00CF \u00D4 \u0152 \u00D9 \u00DB \u0178\u00A0 a b c d e f g h i j k l m n o p q r s t u v w x y z \u00E4 \u00F6 \u00FC \u00DF \u00E0 \u00E7 \u00E9 \u00E8 \u00EA \u00EB \u00EE \u00EF \u00F4 \u0153 \u00F9 \u00FB \u00FF\u00A0 0 1 2 3 4 5 6 7 8 9\u00A0 ! \" \u00A7 % & / ( ) = ? + * # ' - _ \u2013 . : , ; \u20AC $ \u00A5 \u00A2 @ | ",
    '{',
    " ",
    '}',
    " ' \u00BB \u00AB \u201E\u2009\u201C ",
    '<',
    " ",
    '>',
    " \u00AE \u00A9 \u00D7"));
export const longTextInlineStyle = (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        "Apparently we ",
        React.createElement("b", null, "had reached"),
        " a great height in the atmosphere, for the sky was\u00A0 a dead black, and the stars had ceased to twinkle. By the same illusion which\u00A0 lifts the",
        ' ',
        React.createElement("a", { href: "https://www.google.com" }, "horizon of the sea"),
        " to the level of the\u00A0 spectator on a hillside, the sable cloud beneath was dished out, and the car seemed to\u00A0 float in the middle of an"),
    React.createElement("ul", null,
        React.createElement("li", null, "immense dark sphere,"),
        React.createElement("ul", null,
            React.createElement("li", null, "whose upper half"),
            React.createElement("li", null, "was strewn with silver")),
        React.createElement("li", null, "Looking down into the dark gulf")),
    React.createElement("p", null,
        "below, I could see a ruddy",
        React.createElement("sup", null, "1"),
        " light ",
        React.createElement("em", null, "streaming through"),
        " a rift in the clouds.\u00A0 By the same illusion which lifts the horizon",
        React.createElement("sup", null, "2"),
        " of the ",
        React.createElement("i", null, "sea to the level of the spectator"),
        "\u00A0 on a hillside, the sable cloud beneath was dished",
        React.createElement("sub", null, "abc"),
        " out, and the car seemed to float in\u00A0 the middle of an"),
    React.createElement("ol", null,
        React.createElement("li", null, "immense dark sphere,"),
        React.createElement("li", null, "whose upper half")),
    React.createElement("p", null, "was strewn with silver."),
    React.createElement("p", null, "Apparently we had reached a great height in the atmosphere, for the sky was\u00A0 a dead black, and the stars had ceased to twinkle."),
    React.createElement("dt", null, "Description lists"),
    React.createElement("dd", null, "A description list is perfect for defining terms."),
    React.createElement("dt", null, "Euismod"),
    React.createElement("dd", null,
        "Donec id elit non mi porta gravida at eget ",
        React.createElement("mark", null, "metus"),
        ".")));
//# sourceMappingURL=TextSpecimen.js.map